
    import { Component, Vue, Prop, Watch } from 'vue-facing-decorator';
    
    @Component({
        emits: ['save'],
    })
    export default class EditDrivers extends Vue {
        @Prop({ default: null }) public driverFilters: any;
        @Prop({ default: null }) public model: any;

        private modalShow = false;

        private mounted() {
            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape") {
                    if (this.modalShow) this.close();
                }
            });
        }

        @Watch('driverFilters')
        private onDriversChanged(value: any) {
            if (value) {
                this.modalShow = true;
            }
            else {
                this.modalShow = false;
            }
        }

        private async close() {
            const res = await this.$confirm(String(this.$t('message.confirmClose')), { buttonTrueText: String(this.$t('message.yes')), buttonFalseText: String(this.$t('message.no')) });
            if (res) { this.modalShow = false }
        }

        private save() {
            this.$emit('save', this.driverFilters);
        }

        private async removeDriverFilter(driverFilter: any) {
            const res = await this.$confirm('Weet u zeker dat u deze rij wilt verwijderen?', { buttonTrueText: String(this.$t('message.yes')), buttonFalseText: String(this.$t('message.no')) })
            if (res) {
                for (let i = 0; i < this.driverFilters.length; i++) {
                    if (this.driverFilters[i] === driverFilter) {
                        this.driverFilters.splice(i, 1);
                    }
                }
            }
        }

        private addDriverFilter() {
            this.driverFilters.push({ id: -1, function: '', title: '', drivers: [] });
        }

        private async removeDriver(driverFilter: any, driver: any) {
            const res = await this.$confirm('Weet u zeker dat u deze rij wilt verwijderen?', { buttonTrueText: String(this.$t('message.yes')), buttonFalseText: String(this.$t('message.no')) })
            if (res) {
                for (let i = 0; i < driverFilter.drivers.length; i++) {
                    if (driverFilter.drivers[i] === driver) {
                        driverFilter.drivers.splice(i, 1);
                    }
                }
            }
        }

        private addDriver(driverFilter: any) {
            driverFilter.drivers.push({ id: -1, function: '', title: '', roundingDigits: 2, inverse: false });
        }

        private encode() {
            if (this.driverFilters != null) {
                const f1 = this.driverFilters.map(function (f: any) {
                    return {
                        Title: f.title,
                        Function: f.function,
                        Drivers: f.drivers.map(function (f: any) {
                            return { Title: f.title, Function: f.function, Weight: f.weight, RoundingDigits: f.roundingDigits, Inverse: f.inverse };
                        })
                    };
                });
                return f1;
            }
            else {
                return null;
            }
        }
    }
